// import {HashRouter} from 'react-router-dom';

export default {
  routerComponent: null, // HashRouter ou null
  prefixRoutes: '', // préfix utilisé par le HashRouter par défaut mettre # en cas de HashRouter
  pathname: 'pathname', // pathname de référence pathname par défaut, hash pour HashRouter
}
